import {isAttachmentVersion} from './isAttachmentVersion';
import {getAttachmentVersion} from './getAttachmentVersion';

// TODO: create a value object for Attachment
export {
    isAttachmentVersion,
    getAttachmentVersion,
};

